import VueRouter from 'vue-router';
import store from './store';
import Vue from 'vue';

const trans = Vue.prototype.trans;

const title = process.env.MIX_TITLE;

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/members',
      name: 'members',
      // component: Members,
      component: () => import('#js_site/views/pages/Members'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('pages:members.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/match-game',
      name: 'match_game',
      // component: MatchGame,
      component: () => import('#js_site/views/pages/MatchGame'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('pages:match_game.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/visitors',
      name: 'visitors',
      // component: Members,
      component: () => import('#js_site/views/pages/Visitors'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('pages:visitors.title'),
        profile: true,
        showCoins: true,
      },
    }, {
      path: '/chat',
      name: 'chat',
      // component: Chat,
      component: () => import('#js_site/views/pages/Chat'),
      meta: {
        layout: 'ChatLayout',
        title: title + ' | ' + trans.get('pages:chat.title'),
      }
    }, {
      path: '/profile',
      name: 'user',
      // component: User,
      component: () => import('#js_site/views/pages/User'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:index.title'),
        profile: false,
      }
    }, {
      path: '/profile/edit',
      name: 'user.edit',
      // component: UserEdit,
      component: () => import('#js_site/views/pages/UserEdit'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:edit.title'),
        profile: false,
      }
    }, {
      path: '/profile/:id(\\d+)',
      name: 'profile',
      // component: Profile,
      component: () => import('#js_site/views/pages/Profile'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:show.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/more-settings/blocked-members',
      name: 'blocked_members',
      // component: BlockedMembers,
      component: () => import('#js_site/views/pages/MoreSettings/BlockedMembers'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:blocked_member.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/payment/last-chance/:unit',
      name: 'last_chance',
      // component: LastChance,
      component: () => import('#js_site/views/pages/MoreSettings/LastChance'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/success',
      name: 'payment-success',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentSuccess'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/abort',
      name: 'payment-abort',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentAbort'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/failure',
      name: 'payment-failure',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentFailure.vue'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/return',
      name: 'payment-return',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentReturn.vue'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/:unit',
      name: 'payment',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      },
      beforeEnter(to, from, next) {
        store.commit('shop/setSelectedPackage', null);

        if (to.hash !== '#b') {
          store.commit('shop/setVoucher', null);
        }

        next();
        return true;
      },
    }, {
      path: '/more-settings/payment/:unit/:packageId',
      name: 'payment-method',
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      },
    }, {
      path: '/more-settings/payment',
      name: 'payment-coins',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/quiz',
      name: 'quiz',
      // component: Quiz,
      component: () => import('#js_site/views/pages/MoreSettings/Quiz'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:quiz.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/password',
      name: 'password',
      // component: Password,
      component: () => import('#js_site/views/pages/MoreSettings/Password'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:password.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/notifications',
      name: 'notifications',
      // component: Notifications,
      component: () => import('#js_site/views/pages/MoreSettings/Notifications'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:notification.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/faq',
      name: 'faq',
      // component: Faq,
      component: () => import('#js_site/views/pages/MoreSettings/Faq'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('pages:faq.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/payment-history',
      name: 'payment-history',
      // component: PaymentHistory,
      component: () => import('#js_site/views/pages/MoreSettings/PaymentHistory'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:payment_history.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/reports',
      name: 'tickets',
      // component: Tickets,
      component: () => import('#js_site/views/pages/MoreSettings/Tickets'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/terms',
      name: 'terms',
      // component: Terms,
      component: () => import('#js_site/views/pages/MoreSettings/Terms'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:terms.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/reports/:id',
      name: 'tickets.show',
      // component: Ticket,
      component: () => import('#js_site/views/pages/MoreSettings/Ticket'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/more-settings',
      name: 'more-settings',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/restore-account/:hash',
      name: 'restore-account',
      component: () => import('#js_site/views/pages/RestoreAccount.vue'),
      meta: {
        layout: 'HomeLayout',
        title: title + ' | ' + trans.get('pages:restore_account.title'),
        profile: false,
      }
    },
  ],
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    Vue.nextTick(() => {
      document.title = to.meta.title;
    });
  }
});

router.afterEach((to, from) => {
  store.commit('router/setPrevRoute', { path: from.path, name: from.name });
});

router.afterEach((to, from) => {
  store.dispatch('analytics/fbqTrack', { event: 'PageView', p: { content_name: to.path } });
  // store.dispatch('analytics/appsflyer', { eventType: 'EVENT', eventName: 'PageView', eventValue: { path: to.path }});
});

// window.mobile = {
//   platform: 'local',
//   callHandler: function (name) {
//     console.log('========================== window.mobile.callHandler: ' + name, window.mobile.platform);
//   }
// };

function getMobileRedirectTarget(to) {
  // Mobile app params
  // - window.mobile.version_code — numer buildu, np. "248"
  // - window.mobile.version_name — wersja aplikacji, np. "1.0.189"
  // - window.mobile.platform — "ios" lub "android"
  //
  // Nav:
  // - window.mobile.callHandler('pop') - close webview
  // - window.mobile.callHandler('redirect_to:members') - members
  // - window.mobile.callHandler('redirect_to:chat') - chat
  // - window.mobile.callHandler('redirect_to:chat/{id}');
  // - window.mobile.callHandler('redirect_to:profile/{id}');
  // - window.mobile.callHandler('redirect_to:matchgame') - match game
  // - window.mobile.callHandler('redirect_to:in-app-shop') - in-app shop (coins)

  const routeTargets = {
    members: 'members',
    match_game: 'matchgame',
    chat: to.query.profile ? `chat/${to.query.profile}` : 'chat',
    // chat: to.query.profile ? `chat/${to.query.profile}` : 'chat',
    // profile: to.params.id ? `profile/${to.params.id}` : 'members',
    payment: 'in-app-shop',
  };

  return routeTargets[to.name] || null;
}

router.afterEach((to) => {

  if (!window.mobile || typeof window.mobile.callHandler !== 'function') {
    return;
  }

  const allowList = [
    '/mobile',
    '/unsubscribe-email',
    '/more-settings/notifications',
    '/restore-account',
    '/faq',
    '/more-settings/payment/success',
    '/more-settings/payment/failure',
    '/more-settings/payment/return',
    '/terms',
    '/agb',
    '/privacy',
  ];

  if (allowList.some(path => to.path.startsWith(path))) {
    return;
  }

  const mobileTarget = getMobileRedirectTarget(to);
  if (!mobileTarget) {
    window.mobile.callHandler('redirect_to:members');
    return;
  }

  try {
    window.mobile.callHandler(`redirect_to:${mobileTarget}`);
  } catch (e) {
    console.error(e);
  }
});

export default router;
